/**
 * Formateador de moneda para pesos mexicanos (MXN).
 * @type {Intl.NumberFormat}
 */
export const formatoMoneda = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN'
});

/**
 * Elimina las claves con valores `null` de un objeto.
 * @param {Object} data - Objeto original con posibles valores `null`.
 * @returns {Object} - Nuevo objeto sin claves con valor `null`.
 */
export const deleteKeyNull = (data) => {
    const filteredData = { ...data };
    for (const key in filteredData) {
        if (filteredData.hasOwnProperty(key) && filteredData[key] === null) {
            delete filteredData[key];
        }
    }
    return filteredData;
};

/**
 * Extrae el nombre de usuario desde un correo electrónico y agrega un número aleatorio.
 * @param {string} email - Dirección de correo electrónico.
 * @returns {string} - Nombre de usuario generado (formato: usuario.numero).
 */
export const extractUsername = (email) => {
    if (typeof email !== 'string' || !email.includes('@')) {
        return '';
    }
    const [username] = email.split('@');
    const randomNumber = Math.floor(Math.random() * 100001);
    return `${username}.${randomNumber}`;
};

